export default __webpack_public_path__ + "static/media/photo--sm--120.4691954a.jpg";